import {Lang} from 'yougile-lang'
import {logger, TimeInterval} from 'yougile-util'
import {TimerStickerEntry, UserEvent} from 'yougile-model'

export const getActionNameChangeStopwatch = (event: UserEvent): string => {
  if (event.type !== 'stopwatch') {
    return ''
  }

  const {options} = event
  if (!options) {
    return ''
  }

  const oldValue = options?.oldValue
  const newValue = options?.newValue

  if (!oldValue && newValue) {
    return Lang.msg.statsTimeline.statActionStopwatchRun
  }

  if (oldValue && !newValue) {
    return Lang.msg.statsTimeline.statActionStopwatchDetached
  }

  if (oldValue && newValue) {
    if (!oldValue.running && newValue.running) {
      const time = formatTime(newValue)
      return Lang.msg.statsTimeline.statActionStopwatchRunValue(time)
    }

    if (oldValue.running && !newValue.running) {
      const time = formatTime(newValue)
      return Lang.msg.statsTimeline.statActionStopwatchStop(time)
    }
  }

  logger.warn('event', JSON.stringify(event, null, ' '))

  return 'Error'
}

export const formatTime = (entry: TimerStickerEntry): string => {
  return TimeInterval.fromString(entry.time).format(false, false, true)
}
